import { createI18n } from "vue-i18n";
import { getCookie } from '../../public/js/cookie'
import en from '@/lang/en'
import zh from '@/lang/zh'
let lang = getCookie("industryLang");
const i18n = createI18n({
  legacy: false, // 要使用组合式 API，您必须将其设置为 false
  locale: lang||'zh', // 设置默认语言
  fallbackLocale:lang|| 'zh', // 设置回退语言，当当前语言的消息缺失时使用此语言
  messages: {
    en,
    zh,
  },
});

export default i18n;